module.exports = __webpack_public_path__ + "static/logo-cd84376f715edb3bcab67402d6f7549e.png";